<template>
    <div class="container">
       <div class="card mb-3">
           <p>To claim this perk:</p>
           <ul>
               <li>Visit {{perk.claimUrl}}.</li>
               <li>Use the code "{{perk.claimCode}}" during checkout.</li>
           </ul>
       </div>
    </div>
</template>

<script>

export default {

    props: {
        perk: {
            type: Object
        }
    },
}
</script>

<style scoped>

</style>
